import React from "react";
import classNames from "classnames";

import classes from "./style.module.scss";

import { ReactComponent as Icon } from "./icons/preloader.svg";

interface Props {
  className?: string;
}

const Preloader: React.FC<Props> = ({ className }) => (
  <div className={classes.wrapperSpinner}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66px"
      height="66px"
      viewBox="0 0 100 100"
      style={{ animation: 'preloader 1s linear infinite' }}  // 👈
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="#007CFF"
        strokeWidth="10"
        r="35"
        strokeDasharray="164.93361431346415 56.97787143782138"  // 👈 camelCase
      />
    </svg>
  </div>
);

export default Preloader;
